import { useEffect, useState } from 'react'
import {
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View
} from 'react-native'
import { Ionicons, FontAwesome } from '@expo/vector-icons'
import { ParamListBase, useNavigation } from '@react-navigation/native'
import { NativeStackNavigationProp } from '@react-navigation/native-stack'

// styles
import { colorPalette, globalStyles } from '../../static/styles/global'

// components
import ModalPopup from '../shared/modal/ModalPopup'
import StoreIncorrectInfoMesasges from './StoreIncorrectInfoMesasges'

// types
import { Message } from '../../types/communicateTypes'
import { SafeAreaView } from 'react-native-safe-area-context'

interface modalMessageProps {
  title: string
  action?: (message: string) => void
  visible: boolean
  setVisible: any
  userId: number
}

const MessageBoxPopup = ({
  title,
  action,
  visible,
  setVisible,
  userId
}: modalMessageProps): JSX.Element => {
  const [message, setMessage] = useState('')
  const [savedMessage, setSavedMessage] = useState('')
  const [storeMessages, setStoreMessages] = useState<Message[]>(null)

  const navigation = useNavigation<NativeStackNavigationProp<ParamListBase>>()

  const handleSendMessage = (): void => {
    setSavedMessage(message)
    if (action !== null) {
      action(message)
      navigation.navigate('Onboarding')
    }
    setMessage('')
  }

  return (
    <ModalPopup
      visible={visible}
      position="bottom"
      screen="full"
      flatBottom={false}
    >
      <View>
        <View style={styles.modalHeader}>
          <Text
            style={[
              globalStyles.text,
              globalStyles.fs18,
              globalStyles.fwBold,
              globalStyles.blackTextColor
            ]}
          >
            {title}
          </Text>
          <TouchableOpacity onPress={() => setVisible(!visible)}>
            <Ionicons name="close-sharp" size={24} color={colorPalette.black} />
          </TouchableOpacity>
        </View>
        <View style={[styles.modalBody]}>
          <View style={[styles.modalBodyInner]}>
            <View style={[styles.messageInputWrapper]}>
              <TextInput
                multiline
                numberOfLines={4}
                placeholder="Message..."
                style={[globalStyles.input, styles.messageInput]}
                blurOnSubmit={false}
                placeholderTextColor={colorPalette.lightGray}
                value={message}
                onChangeText={(text) => {
                  setMessage(text)
                }}
              />
              <TouchableOpacity
                style={[styles.messageSend]}
                onPress={handleSendMessage}
                disabled={message.trim() === ''}
              >
                <FontAwesome
                  name="send"
                  size={26}
                  color={colorPalette.secondary}
                  style={[message.trim() === '' && { opacity: 0.3 }]}
                />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </View>
    </ModalPopup>
  )
}

const styles = StyleSheet.create({
  modalHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 16,
    paddingVertical: 16,
    borderBottomWidth: 1,
    borderColor: colorPalette.darkLight
  },
  modalBody: {
    paddingVertical: 0,
    paddingHorizontal: 0
  },
  modalBodyInner: {
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 20
  },
  messageInput: {
    textAlignVertical: 'top',
    borderColor: colorPalette.lightGray,
    borderRadius: 50,
    minHeight: 44,
    paddingHorizontal: 20,
    paddingRight: 60,
    paddingTop: 11,
    paddingBottom: 11
  },
  messageInputWrapper: {
    position: 'relative'
  },
  messageSend: {
    position: 'absolute',
    right: 18,
    top: '50%',
    marginTop: -10
  }
})

export default MessageBoxPopup
